import React from 'react';
import { ArrowDown, Shield, Zap, Lock, Database } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-50 to-white overflow-hidden" data-id="element-83">
      {/* Enhanced Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-84">
        <div className="absolute -top-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-blue-50 blur-3xl opacity-50 animate-pulse" data-id="element-85"></div>
        <div className="absolute top-[20%] -left-[10%] w-[30%] h-[30%] rounded-full bg-slate-100 blur-3xl opacity-50 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-86"></div>
        <div className="absolute bottom-[10%] right-[20%] w-[25%] h-[25%] rounded-full bg-blue-100 blur-3xl opacity-30 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-87"></div>

        {/* Floating tech icons */}
        <div className="absolute top-[15%] right-[15%] text-blue-200 opacity-20 animate-float" data-id="element-88">
          <Shield className="h-16 w-16" data-id="element-89" />
        </div>
        <div className="absolute top-[60%] left-[10%] text-slate-300 opacity-20 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-90">
          <Lock className="h-12 w-12" data-id="element-91" />
        </div>
        <div className="absolute bottom-[20%] right-[25%] text-blue-300 opacity-20 animate-float" style={{
        animationDelay: '0.5s'
      }} data-id="element-92">
          <Database className="h-14 w-14" data-id="element-93" />
        </div>
        <div className="absolute top-[40%] right-[5%] text-slate-200 opacity-20 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-94">
          <Zap className="h-10 w-10" data-id="element-95" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full" data-id="element-96">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20" data-id="element-97">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left order-2 lg:order-1" data-id="element-98">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight mb-4" data-id="element-99">
              Arthur Miller
            </h1>
            <h2 className="text-xl sm:text-2xl text-blue-600 font-medium mb-6" data-id="element-100">
              Founder & CEO | CTO | Enterprise Architect | Engineering Leader |
              Financial Infrastructure Innovator
            </h2>
            <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto lg:mx-0 mb-10 leading-relaxed" data-id="element-101">
              Reimagining banking systems for the post-quantum era. Architecting
              trust at scale through modular infrastructure, transparency, and
              ethical innovation.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-102">
              <a href="#about" className="px-8 py-3.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md w-full sm:w-auto text-center" data-id="element-103">
                Read Biography
              </a>
              <a href="#contact" className="px-8 py-3.5 bg-white text-slate-700 font-medium rounded-lg border border-slate-200 hover:bg-slate-50 hover:text-slate-900 transition-colors w-full sm:w-auto text-center" data-id="element-104">
                Get in Touch
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg order-1 lg:order-2" data-id="element-105">
            <div className="relative" data-id="element-106">
              <div className="absolute inset-0 bg-blue-600 rounded-2xl transform translate-x-4 translate-y-4 opacity-10" data-id="element-107"></div>
              <img src="https://cdn.magicpatterns.com/uploads/d5fs7fsMmGw9UFYJHyxXZ3/Screenshot_2026-03-06_at_9.46.07_AM.png" alt="Arthur Miller, Founder & CEO of FiQIS" className="relative rounded-2xl shadow-2xl object-cover w-full h-auto z-10 border border-slate-100" data-id="element-108" />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block" data-id="element-109">
        <a href="#about" className="text-slate-400 hover:text-blue-600 transition-colors" aria-label="Scroll down" data-id="element-110">
          <ArrowDown className="h-6 w-6" data-id="element-111" />
        </a>
      </div>
    </section>;
}